/*
 * @Author: Sam
 * @Date: 2020-10-12 15:23:33
 * @LastEditTime: 2020-11-09 11:53:42
 * @LastEditors: Sam
 * @Description: 
 * @FilePath: \thework\tofba-client\src\utils\get-page-title.js
 * @可以输入预定的版权声明、个性签名、空行等
 */
import defaultSettings from '@/settings'
import i18n from '@/lang'

export default function getPageTitle(pageTitle,title=defaultSettings.title||'') {
  if (pageTitle) {
    return `${i18n.t(`route.${pageTitle}`)} - ${title}`
  }
  return `${title}`
}
